import { useLocation, useParams } from "react-router-dom"
import ProductTypeDetails from "./producttypedetails"
import useFetch from "../../../hook/useFetch"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import useFilter from "../../../hook/useFilter"
import { notificationActions } from "../../../store/notification-slice"
import useIsMobile from "../../../hook/useIsMobile"
import Skeleton from "react-loading-skeleton"
import { producttypeActions } from "../../../store/producttype-slice"
import MobileComponent from './datatable/mobile'
import DesktopComponent from './datatable/desktop'

export default function ProductTypes(){

    const{id}=useParams()

    const { get } = useFetch()
    const [producttypes, setProducttypes] = useState()
    let dispatch=useDispatch()
     const { convertToArray } = useFilter()
let location=useLocation()

     const fetchProducttypes=()=>{
        setProducttypes(null)
        dispatch(producttypeActions.resetProducttypes());
        get('/producttypes', null, (data) => {
            dispatch(notificationActions.setNotification({
                message: data,
                status: false
            }))
        }, (data) => {
            data = convertToArray(data)
            setProducttypes(data)
             dispatch(producttypeActions.setProducttypes(data))

        })
     }
    useEffect(() => {
       fetchProducttypes()
    }, [])

    useEffect(() => {
        if (location.state && location.state.refetch) {

            fetchProducttypes()
        }
    }, [location.state])

   const { isMobile } = useIsMobile()

    if (!producttypes) {
        return <Skeleton count={50} />
    }

    if(id){
        return <ProductTypeDetails id={id} />
    }

    return   <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>
}